import { IDVStatus } from '../../../../utilities/steps'

export const progressionCheckStepNames = {
  ACCOUNT_CREATION_STEP: 'accountCreationStep',
  VERIFY_IDENTITY_STEP: 'verifyIdentityStep',
  SCHEDULE_ORIENTATION_STEP: 'scheduleOrientationStep',
  CONFIRM_ACTIVATION_STEP: 'confirmActivationStep',
  COMPLETE_DELIVERY_STEP: 'completeDeliveryStep',
}

export const underReviewAndHardFailIdvStatuses: IDVStatus[] = [
  IDVStatus.PENDING,
  IDVStatus.NEEDS_REVIEW,
  IDVStatus.FAILED,
  IDVStatus.DECLINED,
]
